import React, { ChangeEvent, useId } from 'react'
import ColorSwatchControl from './ColorSwatchControl.component'

export interface PageColorSettingFieldProps {
  label?: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const PageColorSettingField: React.FC<PageColorSettingFieldProps> = ({
  label = 'Page color',
  value,
  onChange,
}) => {
  const reactId = useId()
  const inputId = `${reactId}-page-color`

  return (
    <div className="mt-tp-page-color-field input-field-container">
      <label className="input-field-label" htmlFor={inputId}>
        {label}
      </label>
      <ColorSwatchControl
        id={inputId}
        value={value}
        onChange={onChange}
        ariaLabel={label}
      />
    </div>
  )
}

export default PageColorSettingField
